<div class="progress-bar-container">
    <div class="bar" [style.width.%]="barWidth">
    </div>
</div>
